import React, { memo, useCallback } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { getPolyglot } from '../../../../../i18n';
import { EventSubCategory } from '../../../../../redux/incident/EventCategory/EventCategory.model';
import { subCategoryLabelSx } from './styles';

interface SubCategoryRowProps {
  categoryId: string;
  sub: EventSubCategory;
  state: 'some' | 'all' | 'none';
  toggleSubCategory: (categoryId: string, subCategoryId: string) => string[];
}

const SubCategoryRow = memo(function SubCategoryRow({
  categoryId,
  sub,
  state,
  toggleSubCategory,
}: SubCategoryRowProps) {
  const polyglot = getPolyglot();
  const handleChange = useCallback(
    () => toggleSubCategory(categoryId, sub.id),
    [toggleSubCategory, categoryId, sub.id]
  );
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={state === 'all'}
          indeterminate={state === 'some'}
          onChange={handleChange}
          size="small"
        />
      }
      label={
        polyglot.t(`incident.policy.edit.categories.${sub.id}`) ?? sub.name_en
      }
      sx={subCategoryLabelSx}
    />
  );
});

export default SubCategoryRow;
